import { initializeApp } from "firebase/app";
import {
  getMessaging,
  getToken,
  Messaging,
  onMessage,
} from "firebase/messaging";
import { FCM_vapidKey } from "./constant";
import { getAuth } from "firebase/auth";
import { isSupported } from "utils/functions";

export const firebaseConfig = {
  apiKey: "AIzaSyDAEuW-i7p9DJU4wr4f_SnR8sDZF1VgAsc",
  authDomain: "venezia-a3d83.firebaseapp.com",
  projectId: "venezia-a3d83",
  storageBucket: "venezia-a3d83.appspot.com",
  messagingSenderId: "980731756991",
  appId: "1:980731756991:web:3f3373b73929b093f4210a",
  measurementId: "G-PRSFZ2JPJZ",
};

const firebaseApp = initializeApp(firebaseConfig);

let messaging: Messaging | null;

if (isSupported())
  messaging =
    Notification?.permission && Notification?.permission === "granted"
      ? getMessaging(firebaseApp)
      : null;

const getFCMToken = async () => {
  try {
    if (!isSupported() || !Notification?.permission || !messaging) return;
    const token = await getToken(messaging, {
      vapidKey: FCM_vapidKey,
    });
    return token;
  } catch {
    return "";
  }
};

const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) return;
    onMessage(messaging, (payload) => {
      new Notification(payload.notification?.title || "Locoptics", {
        body: payload.notification?.body,
      });
      resolve(payload);
    });
  });

const firebaseAuth = getAuth(firebaseApp);

firebaseAuth.useDeviceLanguage();

export { firebaseAuth, onMessageListener, getFCMToken };

export default firebaseApp;
